import '.r{position:fixed;}.ssr-plugin'
import '.cu{top:0;}.ssr-plugin'
import '.bc{left:0px;}.ssr-plugin'
import '.bd{right:0px;}.ssr-plugin'
import '.ge{bottom:0px;}.ssr-plugin'
import '.gu{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gv{z-index:998;}.ssr-plugin'
import '.gw{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a9{height:100vh;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.gx{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.gy{z-index:999;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.i{align-items:center;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.bu{padding:1.5rem;}.ssr-plugin'
import '.gz{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.bz{flex-shrink:0;}.ssr-plugin'
import '.c1{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="r cu bc bd ge gu gv gw"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="r cu a9 a2 ae gx gy g h"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="g i a3 bu gz bz"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="c1 ar bu"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
